import React, { useEffect } from 'react';
import { FormControl, Input, FormLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useAppDispatch } from 'src/redux-app-hooks';
import { NotificationSeverity, showSnackbar } from 'src/features/notifications/notifications.slice';
import { parseHourlyProfileCsv } from './hourlyProfileCsv';

export default function CHPProducer(props: { onChange: (values: number[] | null) => void }) {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const [profileValues, setProfileValues] = React.useState<number[] | null>(null);

    useEffect(() => props.onChange(profileValues), [profileValues]);

    const parseCsv = async (file?: File) => {
        if (!file) {
            setProfileValues(null);
            return;
        }

        const profile = parseHourlyProfileCsv(await file.text());
        if ('error' in profile) {
            // Don't keep sending an earlier file's profile while the input shows the rejected one.
            setProfileValues(null);
            dispatch(showSnackbar({ message: t(profile.error), severity: NotificationSeverity.Error }));
            return;
        }
        setProfileValues(profile.values);
    };

    return (
        <FormControl>
            <FormLabel>{t('CHP producer (cascade where PV is preferred)')}</FormLabel>
            <Input
                type="file"
                slotProps={{ input: { accept: '.csv' } }}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    e.target.files !== null && parseCsv(e.target.files[0])
                }
            />
        </FormControl>
    );
}
